import { render } from "./FeedSideBar.vue.js?vue&type=template&id=2baeb140&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSideBar.vue?vue&type=template&id=2baeb140&scoped=true"
import script from "./FeedSideBar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSideBar.vue?vue&type=script&lang=js"
export * from "./FeedSideBar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSideBar.vue?vue&type=script&lang=js"

import "./FeedSideBar.vue.scss?vue&type=style&index=0&id=2baeb140&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSideBar.vue?vue&type=style&index=0&id=2baeb140&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baeb140"],['__file',"src/Web/scripts/components/FeedSideBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2baeb140"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2baeb140', __exports__)) {
    api.reload('2baeb140', __exports__)
  }
  
  module.hot.accept("./FeedSideBar.vue.js?vue&type=template&id=2baeb140&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSideBar.vue?vue&type=template&id=2baeb140&scoped=true", () => {
    api.rerender('2baeb140', render)
  })

}


export default __exports__